import React, { AnchorHTMLAttributes } from 'react';
import { UploadContainer, UploadItem, Button } from '@vwfs-bronson/bronson-react';

export type FileUploadItemProps = {
    maxFileSize?: number;
    maxFileSizePerFile?: number;
    validFileFormats?: string[];
    files?: File[];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    removeFile: Function;
    progressValue?: string;
    sizeError?: string | React.ReactNode;
    typeError?: string | React.ReactNode;
    sizeAndTypeError?: string | React.ReactNode;
    cancelLabel: string;
    fileSizeFormatter: (bytes: number) => string;
    mainButtonProps?: AnchorHTMLAttributes<HTMLAnchorElement>;
    secondaryButtonProps?: AnchorHTMLAttributes<HTMLAnchorElement>;
};

export const FileUploadItems: React.FC<FileUploadItemProps> = ({
    files,
    removeFile,
    maxFileSize,
    maxFileSizePerFile,
    validFileFormats,
    progressValue = '100',
    sizeError,
    typeError,
    sizeAndTypeError,
    cancelLabel,
    fileSizeFormatter,
    mainButtonProps,
    secondaryButtonProps,
}) => {
    if (!files) {
        return null;
    }

    const getFileError = (fileSize: number, fileType: string, index: number): string | React.ReactNode => {
        const isSizeInvalid =
            (maxFileSize ? maxFileSize < fileSize : false) ||
            (maxFileSizePerFile ? maxFileSizePerFile < fileSize : false);
        const isTypeInvalid = validFileFormats
            ? !validFileFormats.some((type: string) => type.toUpperCase() === fileType.toUpperCase())
            : false;
        if (!isSizeInvalid && !isTypeInvalid) {
            return '';
        }
        const error = isSizeInvalid && isTypeInvalid ? sizeAndTypeError : isSizeInvalid ? sizeError : typeError;
        return (
            <>
                {error}
                <br />
                <Button onClick={(): void => removeFile(index)}>{cancelLabel}</Button>
            </>
        );
    };

    const getFileType = (name: string): string => {
        const lastDot = name.lastIndexOf('.');
        return name.substring(lastDot + 1).toLowerCase() || '';
    };

    return (
        <>
            {files.map(({ name, size }, index) => {
                const type = getFileType(name);
                const error = getFileError(size, type, index);
                return (
                    <UploadContainer.Item key={index}>
                        <UploadItem
                            className={'u-mb-small'}
                            icon="semantic-file"
                            key={index}
                            fileName={name}
                            error={!!error}
                            fileSize={fileSizeFormatter(size)}
                            fileType={type}
                            message={error}
                            hideMainButton
                            onSecondaryButtonClick={(): void => removeFile(index)}
                            progressValue={progressValue}
                            mainButtonProps={mainButtonProps}
                            secondaryButtonProps={secondaryButtonProps}
                        />
                    </UploadContainer.Item>
                );
            })}
        </>
    );
};
